import { PillNav, useAnchoMinimo, usePrefiereMenosMovimiento, type PillNavItem } from '@eg/efectos'
import { forwardRef, Suspense, type AnchorHTMLAttributes } from 'react'
import { Link, NavLink, useLocation } from 'react-router-dom'
import { es } from '../content/es'

type Props = { items: PillNavItem[] }

/** PillNav hablando con React Router: recibe `href` y lo entrega como `to`. */
const EnlaceRouter = forwardRef<HTMLAnchorElement, AnchorHTMLAttributes<HTMLAnchorElement> & { href?: string }>(
  function EnlaceRouter({ href, ...resto }, ref) {
    return <Link ref={ref} to={href ?? '/'} {...resto} />
  },
)

/** Lista de enlaces simple: movimiento reducido, pantallas angostas y mientras carga PillNav. */
function NavSimple({ items }: Props) {
  return (
    <nav className="navegacion" aria-label={es.navegacionPrincipal}>
      <ul>
        {items.map((i) => (
          <li key={i.href}>
            <NavLink to={i.href ?? '/'} end>
              {i.label}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  )
}

/**
 * Navegación principal. Con movimiento reducido o en pantallas angostas queda la lista de enlaces simple;
 * con movimiento y ancho suficiente, PillNav con su indicador deslizante. Los enlaces son siempre <a> reales.
 */
export function NavPildora({ items }: Props) {
  const menos = usePrefiereMenosMovimiento()
  const ancha = useAnchoMinimo(768)
  const { pathname } = useLocation()

  if (menos || !ancha) return <NavSimple items={items} />
  return (
    <Suspense fallback={<NavSimple items={items} />}>
    <PillNav
      items={items}
      activeHref={pathname}
      linkComponent={EnlaceRouter}
      theme="light"
      surface="solid"
      layout="joined"
      size="sm"
      hoverEffect="fill"
      indicator="pill"
      highlightColor="#0647a8"
      highlightTextColor="#ffffff"
      barColor="#eaf5fc"
      textColor="#082b59"
      collapse="auto"
      intro={false}
      ariaLabel={es.navegacionPrincipal}
    />
    </Suspense>
  )
}
